import React from 'react';
import { Alert, AlertTitle, Button, Box, Typography } from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const ImpersonationBanner = () => {
  const { impersonationSession, endImpersonation, impersonationLoading, isImpersonating } = useAuth();
  const location = useLocation();

  if (!isImpersonating) {
    return null;
  }

  const handleEndImpersonation = async () => {
    try {
      await endImpersonation();
    } catch (error) {
      console.error('Failed to end impersonation:', error);
    }
  };

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        borderRadius: 0,
        position: 'sticky',
        top: 0,
        zIndex: 1300, // Higher than Material-UI Drawer (1200) and AppBar (1100)
        '& .MuiAlert-icon': {
          fontSize: '1.5rem'
        }
      }}
      action={
        location.pathname === '/' ? (
          <Button 
            variant="outlined"
            color="inherit" 
            size="small" 
            startIcon={<StopIcon />}
            onClick={handleEndImpersonation}
            disabled={impersonationLoading}
            sx={{
              borderColor: '#8a6914', // Warning alert text color
              color: '#8a6914', // Warning alert text color
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                borderColor: '#8a6914', // Keep the same border color
                backgroundColor: '#8a6914', // Use warning text color as background
                color: '#fff3cd', // Use banner background color for text/icon
              }
            }}
          >
            End Impersonation
          </Button>
        ) : null
      }
    >
      <AlertTitle sx={{ fontWeight: 600 }}>
        Impersonation Mode Active
      </AlertTitle>
      <Box>
        <Typography variant="body2" component="span">
          You are currently viewing the system as{' '}
          <strong>{impersonationSession.targetEmployee.fullName}</strong>
          {' '}({impersonationSession.targetEmployee.email})
        </Typography>
      </Box>
    </Alert>
  );
};

export default ImpersonationBanner;